/**
 * DENET — son baktıkların
 *
 * Hangi ürünlere bakıldığı tarayıcıda duruyor; Liquid bunu bilemez. Ray boş
 * gelir, kartlar burada tek tek isteniyor: `/products/<handle>?view=card`
 * yalnızca kartın HTML'ini döndüren alternatif bir şablon.
 *
 * Ray hiç ürün yoksa DOM'dan tamamen kaldırılır — boş bir başlık bırakmak,
 * bölümü hiç göstermemekten kötü.
 */

import { DenetElement, define } from '@denet/core';

const KEY = 'denet:recent';
const MAX = 12;

/** @returns {string[]} */
export function readRecent() {
  try {
    const raw = JSON.parse(localStorage.getItem(KEY) || '[]');
    return Array.isArray(raw) ? raw.filter((h) => typeof h === 'string') : [];
  } catch {
    return [];
  }
}

/** @param {string} handle */
export function recordRecent(handle) {
  if (!handle) return;
  /* Yeniden bakılan ürün başa alınır: liste "en son" sırasında kalmalı. */
  const list = [handle, ...readRecent().filter((h) => h !== handle)].slice(0, MAX);
  try {
    localStorage.setItem(KEY, JSON.stringify(list));
  } catch {
    /* Gizli sekmede localStorage yazılamaz; ray o oturumda çıkmaz, olsun. */
  }
}

class DnRecent extends DenetElement {
  async mounted() {
    this.track = this.querySelector('[data-ref="track"]');
    const limit = Number(this.dataset.limit) || 8;
    const skip = this.dataset.skip || '';

    /* Ürün sayfasındaysak o ürünü rayda göstermenin anlamı yok. */
    const handles = readRecent()
      .filter((h) => h !== skip)
      .slice(0, limit);

    if (handles.length === 0 || !this.track) {
      this.remove();
      return;
    }

    const cards = await Promise.all(handles.map((h) => this.#card(h)));
    const html = cards.filter(Boolean).join('');

    if (!html) {
      this.remove();
      return;
    }

    this.track.innerHTML = html;
    this.hidden = false;

    /* Ray bağlandığında raf boştu: ok durumlarını yeniden hesaplaması için
       dinlediği olayı gönderiyoruz. */
    window.dispatchEvent(new Event('resize'));
  }

  /** @param {string} handle */
  async #card(handle) {
    try {
      const res = await fetch(`${window.Shopify?.routes?.root || '/'}products/${handle}?view=card`);
      if (!res.ok) return '';
      const html = await res.text();
      /* Silinen ürün 404 yerine boş dönebiliyor; ray delik kalmasın. */
      return html.includes('dn-pcard') ? `<div class="dn-prail__item">${html}</div>` : '';
    } catch {
      return '';
    }
  }
}

define('dn-recent', DnRecent);
